import { useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Modal from "src/components/Modal";
import TaskModalActions from "src/components/forms/TaskForm/modals/task-modal/TaskModalActions";
import TaskModalContent from "src/components/forms/TaskForm/modals/task-modal/TaskModalContent";
import TaskModalHead from "src/components/forms/TaskForm/modals/task-modal/TaskModalHead";
import TaskModalInfo from "src/components/forms/TaskForm/modals/task-modal/TaskModalInfo";
import withTranslation, {
	Translation,
} from "src/components/hoc/withTranslation";
import useFillTask from "src/hooks/api/tasks/useFillTask";
import useTaskForm from "src/hooks/api/tasks/useTaskForm";
import useQueryString from "src/hooks/useQueryString";

interface TaskModalProps extends Translation {
	defaultVisible?: boolean;
	backUrl?: string;
}

const TaskModal = ({ t, defaultVisible, backUrl }: TaskModalProps) => {
	const qs = useQueryString();
	const { id } = useParams();
	const { actions, status } = useTaskForm();
	const { fill, listeners } = useFillTask();
	// useTaskFormAutoSave();
	const navigate = useNavigate();
	const visible = !!(qs?.modal === "create-intern-task" || defaultVisible);
	const location = useLocation();

	useEffect(() => {
		if (!id) {
			fill();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, listeners);

	useEffect(() => {
		if (id) {
			actions.get();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const onClose = () => {
		actions.clear();
		const root = location.pathname;
		const sp = new URLSearchParams(location.search);
		if (backUrl) {
			navigate(backUrl);
			return;
		}

		sp.delete("modal");
		sp.delete("status");

		navigate(`${root}${sp ? `?${sp.toString()}` : ""}`);
	};

	return (
		<Modal
			head="disabled"
			size="medium"
			bodyClassName="p-0"
			{...{ onClose, visible }}
			loading={status === "filling" || status === "loading"}
		>
			<div className="flex justify-between items-start p-4 pt-6 md:pt-8 md:pb-4 md:px-8 sticky top-0 bg-white rounded-t-md z-[20] gap-6">
				<TaskModalHead />
				<TaskModalActions {...{ onClose }} />
			</div>
			<div className="grid grid-cols-[65%,35%] flex-1 overflow-auto rounded-md relative">
				<div className="flex flex-col overflow-auto hide-scrollbar flex-1 max-h-full">
					<div className="flex-1 px-4 md:px-8 flex flex-col">
						<TaskModalContent />
					</div>
				</div>
				<div
					style={{ paddingTop: 0 }}
					className="rounded-md p-4 md:p-8 overflow-hidden hidden md:flex flex-col flex-1"
				>
					<div className="bg-gray-background rounded-md flex flex-col flex-1">
						<TaskModalInfo />
					</div>
				</div>
			</div>
		</Modal>
	);
};

TaskModal.locale = {
	nl: {
		title: "",
	},
	en: {
		title: "",
	},
};

export default withTranslation(TaskModal);
